import React from 'react';
import CheckButton from '../../components/CheckButton';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

type Answer = {
    name: string;
    value: string;
}

const PsychlngclCheckDepression: React.FC = () => {
    const answers: Answer[] = [];
    const goResult = (type: string) => {
        if ("cancel" === type) {
            if(window.confirm("정말 취소 하시겠습니까? '확인' 버튼을 누르면 심리검사목록 페이지로 이동합니다.")) {
                alert("취소되었습니다.");
                window.location.href="/psychlgclCheck/main";
            }
        } else if ("success" === type) {
            if (answers.length < 20) {
                alert("아직 응답하지 않은 문항이 있습니다.");
                return;
            } else {
                let total = 0;
                answers.map((answer) => (
                    total += parseInt(answer.value)
                ));
                let resultCode = '';
                if (0 <= total && total < 21) {
                    resultCode = "001";
                } else if (20 < total && total < 25) {
                    resultCode = "002";
                } else if (24 < total && total < 61) {
                    resultCode = "003";
                }
                window.location.href=`/psychlgclCheck/depression/result/${resultCode}`;
            }
        }
    }

    const handleRadioChnage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {value, name} = e.target;
        if (answers.length > 0) {
            // name이 존재하면
            if (answers.findIndex((element) => element.name === name) !== -1) {
                answers[answers.findIndex((element) => element.name === name)].value = value;
            } else {
                answers.push({name: name, value: value});    
            }
        } else {
            answers.push({name: name, value: value});
        }
    }
    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className="contents">
                        <h2>무료심리검사</h2>
                        <Location locations={[
                            {title: "토닥토닥마음케어", url: "/column/columnList"}
                            , {title: "무료심리검사", url: "/psychlgclCheck/main"}]} 
                            menuName='우울 자가진단'
                        />
                        <div className="mobileface">
					        <div className="testWrap depression">
                                <h3 className="f18 black">우울 자가진단</h3>
                                <div className="visualBox mt23">
                                    <p className="black lh30">
                                        <strong className="f16">지난 1주일 동안의 느낌이나 상태에 대한 질문입니다.</strong><br />
                                        각각의 일들이 1주일 동안 얼마나 자주 있었는지 체크해 주십시오.
                                    </p>
                                </div>
                                <h4 className="f14 green mt30">우울 자가진단 진행 (20문항)</h4>
                                <fieldset className="mt15">
							        <ul className="etc_list col4">
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">1.  평소에는 아무렇지도 않던 일들이 괴롭고 귀찮게 느껴진다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq1" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq1" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq1" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq1" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">2. 먹고 싶지 않고 식욕도 없다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq2" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq2" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq2" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq2" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">3. 어느 누가 도와준다 하더라도 나의 울적한 기분을 떨쳐 버릴 수 없을 것 같다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq3" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq3" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq3" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq3" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">4. 무슨 일을 하든 정신을 집중하기가 힘들었다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq4" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq4" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq4" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq4" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">5. 비교적 잘 지냈다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq5" value="0" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq5" value="1" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq5" value="2" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq5" value="3" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">6. 상당히 우울했다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq6" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq6" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq6" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq6" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">7. 모든 일들이 힘들게 느껴졌다. </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq7" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq7" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq7" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq7" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">8. 앞 일이 암담하게 느껴졌다. </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq8" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq8" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq8" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq8" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">9. 지금까지의 내 인생은 실패작이라는 생각이 들었다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq9" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq9" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq9" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq9" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">10. 적어도 보통 사람들만큼의 능력은 있었다고 생각한다. </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq10" value="0" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq10" value="1" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq10" value="2" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq10" value="3" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">11. 잠을 설쳤다.(잠을 잘 이루지 못했다) </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq11" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq11" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq11" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq11" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">12. 두려움을 느꼈다. </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq12" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq12" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq12" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq12" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">13. 평소에 비해 말수가 적었다. </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq13" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq13" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq13" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq13" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">14. 세상에 홀로 있는 듯한 외로움을 느꼈다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq14" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq14" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq14" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq14" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">15. 큰 불만 없이 생활했다. </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq15" value="0" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq15" value="1" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq15" value="2" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq15" value="3" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">16. 사람들이 나에게 차갑게 대하는 것 같았다. </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq16" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq16" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq16" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq16" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">17. 갑자기 울음이 나왔다. </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq17" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq17" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq17" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq17" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">18. 마음이 슬펐다. </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq18" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq18" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq18" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq18" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">19. 사람들이 나를 싫어하는 것 같았다. </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq19" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq19" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq19" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq19" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">20. 도무지 뭘 해 나갈 엄두가 나지 않았다.  </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="dq20" value="3" onChange={handleRadioChnage}/> 1주일에 5일 이상</label>
                                                    <label><input type="radio" name="dq20" value="2" onChange={handleRadioChnage}/> 1주일에 3~4일간</label>
                                                    <label><input type="radio" name="dq20" value="1" onChange={handleRadioChnage}/> 1주일에 1~2일간</label>
                                                    <label><input type="radio" name="dq20" value="0" onChange={handleRadioChnage}/> 1주일에 1일 이하</label>
                                                </dd>
                                            </dl>
                                        </li>
							        </ul>
						        </fieldset>
                                <CheckButton goResult={goResult} />
					        </div>
				        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PsychlngclCheckDepression;